<template>
    <div class="horizontal-divider">
        <div class="horizontal-divider__label" v-if="label">{{label}}</div>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String
            }
        }
    };
</script>
